import { useTranslations } from "next-intl";
import Link from "next/link";
import React from "react";

interface INavListItemProps {
  title: string;
  href?: string;
  onClick?: () => void;
}

const NavListItem = ({ title, href, onClick }: INavListItemProps) => {
  const t = useTranslations();
  const linkClass = `relative inline-block py-1 px-1 group`;
  const bottomLineClass = `absolute left-0 bottom-0 h-[2px] w-full scale-x-0 origin-left bg-primary transition-transform duration-300 group-hover:scale-x-100`;

  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const targetElement = document.getElementById(title);
    
    // If we're on the same page and the element exists, scroll smoothly
    if (targetElement && window.location.pathname === "/") {
      e.preventDefault();
      targetElement.scrollIntoView({ behavior: "smooth" });
      // Update URL hash without triggering navigation
      window.history.pushState(null, "", `/#${title}`);
    }
    // Otherwise, let Next.js handle the navigation (different page → homepage)
    
    onClick?.();
  };

  if (href) {
    return (
      <Link onClick={onClick} href={href} className={linkClass} prefetch>
        <span className="relative z-10">{t(title)}</span>
        <span className={bottomLineClass} />
      </Link>
    );
  }

  return (
    <Link
      onClick={handleAnchorClick}
      href={`/#${title}`}
      className={linkClass}
      scroll={false}
      prefetch
    >
      <span className="relative z-10">{t(title)}</span>
      <span className={bottomLineClass} />
    </Link>
  );
};

export default NavListItem;
